import React from 'react';

import LFModal from 'components/common/LFModal';

import { MedianClockInTime } from './MedianClockInTime';
import { ClockInHistoryTable } from './ClockInHistoryTable';

type CalendarDay = {
  date: string;
  checkinTime?: string | null;
  isWeekend?: boolean;
  holiday?: {
    name: string;
  } | null;
  worklog?: {
    location?: string;
  } | null;
  leave?: {
    isAutomated?: boolean;
  } | null;
};

type UnfreezeRequest = {
  date?: string;
};

type ClockInHistoryModalProps = {
  TriggerBtn: React.ComponentType<{ onClick: () => void; interactive: boolean; isLoading?: boolean }>;
  isOpen: boolean;
  onClose: () => void;
  isEdit?: boolean;
  clockinHistoryData: CalendarDay[];
  isClockinHistoryLoading: boolean;
  medianClockInTime: string | null;
  unfreezeRequests: UnfreezeRequest[];
  modalHeader?: string;
};

export function ClockInHistoryModal({
  TriggerBtn,
  isOpen,
  onClose,
  clockinHistoryData,
  isClockinHistoryLoading,
  medianClockInTime,
  unfreezeRequests,
  modalHeader = 'My clock-in time history',
}: ClockInHistoryModalProps) {
  return (
    <LFModal
      TriggerBtn={TriggerBtn}
      isOpen={isOpen}
      onClose={onClose}
      closeButton
      htmlContent={
        <>
          <MedianClockInTime clockInTime={medianClockInTime} />
          <ClockInHistoryTable
            clockinHistoryData={clockinHistoryData}
            isLoading={isClockinHistoryLoading}
            unfreezeRequests={unfreezeRequests}
          />
        </>
      }
      title={{
        text: modalHeader,
        type: 'info',
      }}
      className="clockin-history-modal"
    />
  );
}
